<template>
  <div class="candidate-planning p-t-30">
    <h1 class="page-title">
      {{ $i18n.t('CandidatePlanning.title') }} {{ candidate.first_name }} {{ candidate.last_name }}
    </h1>

    <candidate-planning-calendar-monthly
      :unavailabilityDateList="unavailabilityDateList"
      @updateDateRange="updateDateRange"
      :unavailabilityDateScheduled="unavailabilityDateScheduled"
      :userId="userId" />
    <br>
    <candidate-planning-table
      v-if="unavailabilityDateListScoped && unavailabilityDateListScoped.length > 0"
      :start_at="start_at"
      :end_at="end_at"
      :unavailabilityDates="unavailabilityDatesWithDistinctOffers" />

    <no-data class="p-t-20" v-else></no-data>
  </div>
</template>

<script type="text/javascript">
import moment from 'moment-timezone'
import { mapGetters, mapActions } from 'vuex'
import NoData from '../common/NoData'
import CandidatePlanningCalendarMonthly from './CandidatePlanningCalendarMonthly'
import CandidatePlanningTable from './CandidatePlanningTable'

  export default {
    name: 'CandidatePlanning',
    components: {
      NoData,
      CandidatePlanningCalendarMonthly,
      CandidatePlanningTable
    },
    data() {
      return {
        offerIds: [],
        start_at: null,
        end_at: null
      }
    },
    computed: {
      ...mapGetters({
        currentUser: 'auth/currentUser',
        unavailabilityDateList: 'unavailabilityDates/unavailabilityDateList',
        unavailabilityDateListScoped: 'unavailabilityDates/unavailabilityDateListScoped',
        unavailabilityDateScheduled: 'unavailabilityDates/unavailabilityDateScheduled',
        candidate: 'users/user',
      }),
      unavailabilityDatesWithDistinctOffers() {
        if (this.unavailabilityDateListScoped != null) {
          var unavailabilityDateListScoped = this.unavailabilityDateListScoped.filter(this.offerAlreadyDisplayed);
          this.offerIds = [];
          return unavailabilityDateListScoped;
        }
        return []
      },
      entityId(){
        return this.$route.params.entity_id;
      },
      userId(){
        return this.$route.params.user_id;
      },
      filter_params(){
        return {
          start_at_gt: moment().startOf('month').format(this.$i18n.t('format.date')),
          end_at_lt: moment().endOf('month').format(this.$i18n.t('format.date'))
        }
      },
    },
    methods: {
      ...mapActions({
        loadListDates: 'unavailabilityDates/loadListWithParams',
        loadList: 'unavailabilityDates/loadList',
        loadUnavailabilityDateScheduled: 'unavailabilityDates/loadUnavailabilityDateScheduled',
        getUser: 'users/get',
      }),
      offerAlreadyDisplayed(unavailabilityDate) {
        if (unavailabilityDate.offer == null) {
          return true
        }
        if (this.offerIds.includes(unavailabilityDate.offer.id)) {
          return false;
        } else {
          this.offerIds.push(unavailabilityDate.offer.id);
          return true;
        }
      },
      updateDateRange(startAt, endAt) {
        this.loadListDates({ userId: this.userId, params: {start_at_gt: startAt, end_at_lt: endAt} });
        this.start_at = startAt;
        this.end_at = endAt;
      },
    },
    mounted: function() {
      this.loadList(this.userId);
      this.loadListDates({ userId: this.userId, params: this.filter_params });
      this.loadUnavailabilityDateScheduled({
        user_id: this.userId,
        start_date: moment().startOf('month').format(this.$i18n.t('format.date')),
        end_date: moment().endOf('month').format(this.$i18n.t('format.date'))
      })
      this.start_at = this.filter_params.start_at_gt
      this.end_at = this.filter_params.end_at_lt
      this.getUser({ userId: this.userId, entityId: this.entityId });
    }
  }
</script>

<style scoped lang="scss">
  h1 {
    padding-left: 13px;
  }
  .candidate-planning {
    max-width: 1200px;
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/users/CandidatePlanning.vue